import { useDispatch, useSelector } from 'react-redux'
import { Sparkles as SparklesIcon } from 'lucide-react'
import { withIcon3D } from '@/components/icons3d/Icon3D'

const Sparkles = withIcon3D('assistant', SparklesIcon)
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { togglePanel } from '@/features/aiChat/aiChatSlice'
import { selectAssistantVisible } from '@/features/aiChat/panelVisibility'
import { useLoadAssistantStatus } from '@/features/aiChat/useLoadAssistantStatus'
import { ASK_GRAPHIT } from '@/components/assistant/copy'
import { assistAnchor } from '@/features/assist/anchors'

/**
 * Header trigger for the assistant panel. Hidden when the plan does not
 * include it (`selectAssistantVisible`: a budget pause still shows).
 */
export default function AiChatButton() {
  const dispatch = useDispatch()
  const panelOpen = useSelector((s) => s.aiChat.panelOpen)
  const isVisible = useSelector(selectAssistantVisible)
  useLoadAssistantStatus()

  if (!isVisible) return null

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={panelOpen ? 'secondary' : 'ghost'}
          size="sm"
          aria-label={ASK_GRAPHIT}
          {...assistAnchor('assistant.open')}
          aria-pressed={panelOpen}
          onClick={() => dispatch(togglePanel())}
        >
          <Sparkles className="size-5" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{ASK_GRAPHIT}</TooltipContent>
    </Tooltip>
  )
}
